<template>
    <div class="corrections-comment" v-html="normalizedText"></div>
</template>

<script>
function replaceLinks(text) {
    return (text || '').replace(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi, function(
        _,
        space,
        url
    ) {
        let link = url;
        if (!link.match('^https?://')) {
            link = 'http://' + link;
        }
        return space + '<a class="link" target="_blank" href="' + link + '">' + url + '</a>';
    });
}

export default {
    name: 'CorrectionsComment',
    props: {
        text: {
            type: String,
            required: true
        }
    },
    computed: {
        normalizedText() {
            return replaceLinks(this.text);
        }
    }
};
</script>

<style src="./CorrectionsComment.scss" lang="scss"></style>
